/* ============================================================================
   Tour do aluno — DEFINIÇÃO DOS PASSOS
   ============================================================================
   Dados puros: nenhum import, nenhum React, nenhum DOM. O formato de um passo e
   as constantes compartilhadas estão em ./index.js.

   O TOM É DIFERENTE DO ROTEIRO DO PROFESSOR, e de propósito: quem lê é criança
   ou adolescente. Frases curtas, segunda pessoa direta, nada de vocabulário de
   gestão ("alocar", "acompanhar desempenho"). O que o aluno quer saber é onde
   está a tarefa dele e o que ganha fazendo.

   O QUE ESTE ROTEIRO PRESSUPÕE
   Quatro das seis áreas existem só para o ALUNO GAMIFICADO — as três primeiras
   entradas do menu e as duas medalhas do topo:

   - "Minhas turmas", "Atividades" e "Minhas Conquistas" são injetadas no front
     pelo Sidebar quando `role_id === 7` E o usuário tem o módulo Gameficandus
     (id 62, ver utils/accessSession.js);
   - "Ofensiva" (StreakBadge) e "Nível e XP" (XpBadge) só renderizam com
     `active_roles.type === "A"`, o mesmo módulo, e resposta dos endpoints
     `streaks/me` / `xp/me`.

   Ou seja: aluno sem Gameficandus, ou aluno cuja ofensiva ainda não existe, tem
   um tour MENOR. Isso não é falha — o filtro descarta o passo sem alvo e a
   numeração se ajusta (ver ../filtro.js). O aluno novo, que ainda não tem
   ofensiva nenhuma, simplesmente não recebe aquele passo.

   ÂNCORAS QUE NÃO SÃO ÓBVIAS

   - **Atividades** não pode ser ancorada por href. A URL do item é dinâmica: o
     Sidebar a monta com a primeira atividade pendente
     (`/classroom/{room_id}/activities`) e cai em `/dashboard` enquanto a
     requisição não volta. Então o alvo é o NOME do item.
   - **Conteúdos** é uma seção com filhos, e o cabeçalho de uma seção dessas não
     tem href — o Sidebar passa `to` ao CSidebarNavDropdown, que vira atributo do
     <li>, não link do toggle. Também vai por nome. Como todo dropdown do AVA
     nasce fechado, é o `abrirDropdowns` que revela o que estiver dentro.
   - **Ofensiva e Nível/XP** ficam no header e não têm classe própria: os dois são
     `CDropdown` com `c-header-nav-item`, igual a notificações e avatar. Por isso
     ganharam `data-tour` explícito nos componentes.
   ========================================================================== */

const PASSOS = [
  {
    id: "boas-vindas",
    alvo: "body",
    posicao: "center",
    verificarNoInicio: false,
    titulo: "Vamos conhecer a plataforma",
    texto:
      "Em poucos passos, você conhecerá os principais recursos da plataforma. " +
      "Vamos mostrar onde encontrar suas turmas, suas atividades e acompanhar " +
      "seu progresso. Você pode encerrar este tour quando quiser e retomá-lo " +
      "pelo ícone de ajuda no topo da tela."
  },

  /* --------------------------------------------------------- nível e XP ----- */
  {
    id: "nivel-xp",
    alvo: '[data-tour="nivel-xp"]',
    posicao: "bottom",
    verificarNoInicio: true,
    titulo: "Seu nível e seu XP",
    texto:
      "Ao concluir atividades, você ganha pontos de experiência (XP) e evolui " +
      "de nível. A barra abaixo do número mostra quanto falta para alcançar o " +
      "próximo nível. Clique para ver mais detalhes."
  },

  /* ------------------------------------------------------------- ofensiva --- */
  {
    id: "ofensiva",
    alvo: '[data-tour="ofensiva"]',
    posicao: "bottom",
    verificarNoInicio: true,
    titulo: "Sua ofensiva",
    texto:
      "A chama representa a quantidade de dias consecutivos em que você acessou " +
      "a plataforma para estudar. Mantenha sua sequência realizando atividades " +
      "regularmente e evite perder sua ofensiva."
  },

  /* ---------------------------------------------------------------- turmas -- */
  {
    id: "menu-turmas",
    alvo: '.c-sidebar-nav-link[href="/classroom/me"]',
    alvoPorTexto: ["minhas turmas"],
    posicao: "right",
    verificarNoInicio: true,
    permiteCliqueNoAlvo: true,
    titulo: "Minhas Turmas",
    texto:
      "Aqui estão todas as turmas das quais você faz parte. Em cada uma delas " +
      "você encontrará materiais, atividades e conteúdos relacionados às suas " +
      "disciplinas."
  },

  /* ------------------------------------------------------------ atividades -- */
  {
    id: "menu-atividades",
    // Sem seletor de href de propósito: a URL deste item é dinâmica.
    alvoPorTexto: ["atividades"],
    posicao: "right",
    verificarNoInicio: true,
    titulo: "Minhas Atividades",
    texto:
      "Nesta área, você acompanha todas as suas atividades. O indicador em " +
      "vermelho mostra quantas ainda estão pendentes, e cada atividade possui " +
      "um prazo para entrega."
  },

  /* ------------------------------------------------------------- conquistas -- */
  {
    id: "menu-conquistas",
    alvo: '.c-sidebar-nav-link[href="/achievements"]',
    alvoPorTexto: ["conquista"],
    posicao: "right",
    verificarNoInicio: true,
    titulo: "Minhas Conquistas",
    texto:
      "Aqui ficam registradas as conquistas obtidas ao longo da sua jornada. " +
      "Continue realizando atividades para desbloquear novas medalhas e " +
      "acompanhar sua evolução."
  },

  /* ------------------------------------------------------------ conteúdos --- */
  {
    id: "menu-conteudos",
    // O cabeçalho de uma seção com filhos não tem href.
    alvoPorTexto: ["conteudo"],
    posicao: "right",
    verificarNoInicio: true,
    titulo: "Conteúdos",
    texto:
      "Nesta seção, você encontra jogos, livros, animações e diversos materiais " +
      "para complementar seus estudos. Explore os conteúdos e aprenda de forma " +
      "interativa."
  },

  {
    id: "fim",
    alvo: "body",
    posicao: "center",
    verificarNoInicio: false,
    titulo: "Tour concluído!",
    texto:
      "Agora você já conhece os principais recursos da plataforma. Sempre que " +
      "quiser revisar este tour, basta clicar no ícone de ajuda localizado no " +
      "topo da tela. Bons estudos!"
  }
];

export default PASSOS;
